import type { ReactNode } from 'react';

import { EmptyRow } from '@/components/empty-row';

type EmptyResultProps = {
  icon: ReactNode;
  title: string;
  description?: string;
  /** Show a create button when there is no active query */
  onCreate?: () => void;
  createButtonText?: string;
  /** When true, shows a clear-filters button instead of the create button */
  hasQuery?: boolean;
  onClear?: () => void;
};

export const EmptyResult = ({
  icon,
  title,
  description,
  onCreate,
  createButtonText,
  hasQuery,
  onClear,
}: EmptyResultProps) => {
  return (
    <EmptyRow>
      {icon}
      {hasQuery ? (
        <EmptyRow.ClearFiltersButton title={title} onClear={onClear}>
          {description}
        </EmptyRow.ClearFiltersButton>
      ) : onCreate ? (
        <EmptyRow.CreateNewButton title={title} onCreate={onCreate} buttonText={createButtonText!}>
          {description}
        </EmptyRow.CreateNewButton>
      ) : (
        <div className="space-y-1 text-center">
          <p className="text-sm font-medium">{title}</p>
          {description && <p className="text-xs text-muted-foreground">{description}</p>}
        </div>
      )}
    </EmptyRow>
  );
};
